import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ChevronRight, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { navLinks } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [svcOpen, setSvcOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    setSvcOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#08080a]/85 backdrop-blur-md border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <Logo />

        {/* Desktop */}
        <div className="hidden lg:flex items-center gap-10">
          {navLinks.map((link) =>
            link.children ? (
              <div
                key={link.label}
                className="relative"
                onMouseEnter={() => setSvcOpen(true)}
                onMouseLeave={() => setSvcOpen(false)}
              >
                <button className="font-mono-l text-[13px] tracking-wide text-stone-300 hover:text-white transition-colors flex items-center gap-1">
                  {link.label}
                </button>
                <div
                  className={`absolute top-full left-1/2 -translate-x-1/2 pt-4 transition-all duration-300 ${
                    svcOpen ? "opacity-100 visible translate-y-0" : "opacity-0 invisible -translate-y-1"
                  }`}
                >
                  <div className="w-[280px] bg-[#0d0d10] border border-white/10 clip-corner p-2">
                    {link.children.map((c) => (
                      <Link
                        key={c.path}
                        to={c.path}
                        className="flex items-center justify-between px-4 py-3 text-stone-300 hover:text-white hover:bg-white/5 transition-colors group"
                      >
                        <span className="text-sm">{c.label}</span>
                        <ChevronRight className="w-4 h-4 text-stone-600 group-hover:text-[#c8a951] transition-colors" />
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <Link
                key={link.path}
                to={link.path}
                className="font-mono-l text-[13px] tracking-wide text-stone-300 hover:text-white transition-colors hover-line"
              >
                {link.label}
              </Link>
            )
          )}
          <Link
            to="/contact"
            className="btn-gold clip-corner px-5 py-2.5 text-[13px] font-semibold flex items-center gap-1.5"
          >
            Get in touch <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          className="lg:hidden text-stone-200"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-400 bg-[#0a0a0c] border-b border-white/10 ${
          open ? "max-h-[420px]" : "max-h-0"
        }`}
      >
        <div className="px-6 py-5 flex flex-col gap-1">
          {navLinks.flatMap((link) =>
            link.children
              ? link.children.map((c) => (
                  <Link key={c.path} to={c.path} className="py-3 text-stone-300 border-b border-white/5">
                    {c.label}
                  </Link>
                ))
              : [
                  <Link key={link.path} to={link.path} className="py-3 text-stone-300 border-b border-white/5">
                    {link.label}
                  </Link>,
                ]
          )}
          <Link to="/contact" className="btn-gold clip-corner mt-4 px-5 py-3 text-sm font-semibold text-center">
            Get in touch
          </Link>
        </div>
      </div>
    </header>
  );
}
